/* @flow weak */
import Offline from 'offline-js/js/offline';

Offline.options = {
  // TODO: We should test an endpoint on API. If using CORS, make sure IE8/9 works. May need to
  // switch to using the image method, but possible to update `offline-js` to use XDomainRequest.
  checks: {
    xhr: { url: '/' },
  },
};

export default Offline;



// WEBPACK FOOTER //
// ./src/lib/Offline.js